import { PartySuggestions } from '@pulse-web-ui/dadata';

import { InstanceUrls, RequestMethods, useQueryFunction } from '@shared/index';

import { type DadataPartySuggestionsProps } from './dadata-party-suggestions.types';

export const DaDataPartySuggestion = (props: DadataPartySuggestionsProps) => {
  const queryFn = useQueryFunction(
    {
      method: RequestMethods.POST,
      url: 'api/v3/dadata/suggest/party',
    },
    InstanceUrls.DADATA_URL
  );

  return (
    <PartySuggestions
      delay={250}
      customRequest={queryFn}
      minChars={1}
      {...props}
    />
  );
};
